import { render, staticRenderFns } from "./AccreditedReportingData.vue?vue&type=template&id=9998c9d4"
import script from "./AccreditedReportingData.vue?vue&type=script&lang=js"
export * from "./AccreditedReportingData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports